import { IConclusionSaveData } from '../../resource/conclusion/conclusion.types';
import { ISession } from '../../resource/session/session.types';
import { IUser } from '../../resource/user/user.types';
import { IApiRequestConfig } from '../api.types';

export const saveConclusionApi = (
  sessionId: ISession['id'],
  userId: IUser['id'],
  conclusion: IConclusionSaveData,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveConclusion',
  uri: 'json',
  action: `sessions/${sessionId}/conclusions/${userId}`,
  method: 'patch',
  data: conclusion,
  v2: true,
});

export const deleteConclusionApi = (sessionId: ISession['id'], userId: IUser['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteConclusion',
  uri: 'json',
  action: `sessions/${sessionId}/conclusions/${userId}`,
  method: 'delete',
  v2: true,
});

export const searchConclusionsApi = (sessionId: ISession['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getConclusions',
  uri: 'json',
  action: `sessions/${sessionId}/conclusions`,
  method: 'get',
  data: { sessionId },
  v2: true,
});
